import { getTrolley } from 'redux/modules/trolley/selectors/get-items';
import { createSelector } from 'reselect';

const EMPTY_ARRAY = [];

export const getTrolleyItemsSetForRemoval = createSelector(
  getTrolley,
  trolley => trolley?.trolleyItemsSetForRemoval ?? EMPTY_ARRAY,
);
